import React, { useEffect } from "react";
import { connect } from "react-redux";
import { ReactComponent as Up } from "../../assets/icons/arrow_upward-24px.svg";
import Footer from "../../Components/Common/Footer";
import Header from "../../Components/Common/Header";
import ApplicationDownload from "../../Components/Home/ApplicationDownload";
import Companies from "../../Components/Home/Company";
import Description from "../../Components/Home/Description";
import Login from "../../Components/Login/Login";
import FAQ from "../../Components/FAQ";
const height = window.innerHeight;
const TopBtn = () => {
  return (
    <div
      className="topBtn"
      id="topBtn"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    >
      <Up />
    </div>
  );
};

const Home = ({ ...props }) => {
  useEffect(() => {
    window.addEventListener("scroll", handeleScroll);
    return () => {
      window.removeEventListener("scroll", handeleScroll);
    };
  }, []);
  const handeleScroll = () => {
    if (document.documentElement.scrollTop > height) {
      document.getElementById("topBtn").style.display = "flex";
    } else {
      document.getElementById("topBtn").style.display = "none";
    }
  };
  const { Open, isLogin } = props;
  return (
    <div className="container">
      <Header isLogin={isLogin} />
      <Companies name={true} />
      <Description isLogin={isLogin} />
      <FAQ />
      <ApplicationDownload />
      <Footer isLogin={isLogin} />
      <TopBtn />
      {Open && <Login />}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    Open: state.init.loginOpen,
    isLogin: state.auth.isLogin,
  };
};

export default connect(mapStateToProps)(Home);
